<template>
	<div class="content">
		<div class="content-view">
			<div class="logo">
				<img src="../assets/logo(1).png">
				<a href="http://www.micp.org.cn/">返回首页</a>
			</div>
			<div class="banner">
				<img src="../assets/国家顶级节点标识首页_07.jpg">
			</div>
			<div class="notice">
				<div class="notice-title">
					工业和信息化部关于印发《工业互联网标识管理办法》的通知
				</div>
				<div class="notice-conten1">
					<img src="../assets/国家顶级节点标识首页_11.jpg">
					<div class="notice-des">
						<div class="notice-head">国家顶级节点标识</div>
						<div class="line1"></div>
						<div class="notice-con">
						    <p>
							  标识解析国家顶级节点是一个国家或</br>者地区内部最顶级的标识解析服务节点
						    </p>							<p>
								能够面向全国范围提供顶级标识编码</br>注册和标识解析服务，以及标识备案、</br>标识认证等管理能力。
							</p>
						</div>
					</div>
				</div>
				<div class="notice-conten2">
					<div class="notice-des">
						<div class="notice-head">国家顶级节点标识解析服务</div>
						<div class="line2"></div>
						<div class="notice-con">
						      全球有多个根结点，每一个根多节点都是独立、平等的。根节点是标识管理体系中最高等级的国际性标识服务节点，提供面向全球范围或者若干国家/地区的公共的根级别的标识服务。
						</div>
					</div>
					<img src="../assets/国家顶级节点标识首页_15.jpg">
				</div>
				<div class="notice-conten3">
					<div v-for="(item,index) in contentList" :key="index">
						<div class="title">{{item.title}}</div>
						<div class="cont">{{item.cont}}</div>
					</div>
				</div>
				<div class="bannerB">
					<img src="../assets/国家顶级节点标识首页_19.jpg">
				</div>
				<div class="server">
					<div class="server-top">
						<img src="../assets/国家顶级节点标识首页_23.png">
						<div class="server-head">标识应用服务</div>
					</div>
					<div class="server-con">
						<div class="server-list">
							<div class="server-item" v-for="(item,index) in serverList" :key="index">
								<div class="server-title">{{item.title}}</div>
								<router-link :to="{path:'/showContent',query:{type:item.type}}">
									<div class="server-more">更多>></div>
								</router-link>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		<Bottom />
	</div>
</template>

<script>
	import Bottom from "../components/bottom.vue"
	export default{
		name:"index",
		components:{
			Bottom
		},
		data(){
			return{
				contentList:[
					{
						title:'国家顶级节点',
						cont:'是一个国家或地区内部最顶级的标识服务节点，能够面向全国/全区范围提供标识注册分配、标识解析审核认证及数据托管等服务，并为行业节点和企业节点提供查询指引国家顶级节点向上与支持各类标识体系的国际根节点保持连通，向下与国内/区内各行业（或企业）二级节点保持连通。'
					},
					{
						title:'二级节点',
						cont:'是面向特定行业平台、通用性平台或大型企业平台提供标识服务的公共节点，可以根据行业具体需求定义灵活的行业性标识数据格式。二级节点向上连接国家顶级节点，向下为工业企业分配标识资源、提供标识注册、解析、公共查询等数据服务，同时满足稳定性、安全性和可扩展性等多方面的要求。二级节点是推动工业互联网标识产业规模化发展和应用的重要抓手，对于树立有价值的行业标识应用标杆、开创可持续发展的业务模式至关重要。'
					},
					{
						title:'企业节点',
						cont:'是面向工业企业内部的标识服务节点可以面向特定企业提供标识内部注册分配和标识解析服务，可以独立部署也可以作为企业信息系统的一部分。根据企业规模可以灵活定义企业内标识解析系统组网形式以及企业内部标识数据格式。企业节点的标识编码与标识解析服务不限定技术方案可与国家顶级节点实现不同标识解析体系之间的互联互通。'
					},
					{
						title:'公共递归节点',
						cont:'是标识解析体系的关键入口设施，代替用户进行复杂的迭代查询。利用缓存技术，也可以将查询结果直接返回给用户，提升整体解析服务性能。当收到客户端的标识解析请求时，公共递归节点首先会在本地缓存进行查询，如果没有命中查询结果，则会查询标识解析服务器，按照其返回的应答查询路径进行查询，直至查询到标识对应的地址和关联信息，将其返回给用户并将查询响应结果进行缓存。'
					}
				],
				serverList:[
					{
						title:'企业官媒标识服务节点建设内容',
						type:'3'
					},
					{
						title:'企业官媒应用标识服务',
						type:'4'
					}
				]
			}
		}
	}
</script>

<style>
	body
	{
		background: #ffffff;
	}
	img
	{
		display: block;
	}
	a
	{
		text-decoration: none;
	}
	.content
	{
		background: #ffffff;
	}
	.content-view
	{
		width: 1680px;
		margin: auto;
	}
	.logo
	{
		margin-top: 30px;
		display:flex;
		justify-content:space-between;
		align-items:center;
	}
	.logo a
	{
		color: #000;
		font-size: 16px;
	}
	.logo img
	{
		height:60px;
	}
	.banner
	{
		margin-top: 13px;
	}
	.banner img
	{
		width: 100%;
	}
	.notice
	{
		margin-top: 60px;
	}
	.notice-title
	{
		font-size: 35px;
		color: #444444;
		text-align: center;
	}
	.notice-conten1
	{
		background: #f5f5f5;
		padding: 40px 20px;
		box-sizing: border-box;
		margin-top: 40px;
		display: flex;
	}
	.notice-conten2
	{
		background: #f5f5f5;
		padding: 40px 20px;
		box-sizing: border-box;
		margin-top: 20px;
		display: flex;
		justify-content: space-between;
	}
	.notice-conten3
	{
		background: #f5f5f5;
		padding-top: 40px;
		box-sizing: border-box;
		margin-top: 20px;
		display: flex;
	}
	.notice-conten3>div
	{
		flex: 1;
		/* padding: 0 10px; */
	}
	.notice-conten3>div .title
	{
		width: 196px;
		height: 70px;
		line-height: 70px;
		background: #ffffff;
		
		margin: auto;
		margin-bottom: 12px;
		font-size: 28px;
		text-align: center;
	}
	.notice-conten3>div .cont
	{
		background: #ffffff;
		font-size: 18px;
		height: 360px;
		line-height: 32px;
		padding: 5px 15px;
		padding-bottom: 20px;
	}
	.notice-conten2 .notice-des
	{
		width: 610px;
		margin-left: 100px;
	}
	.notice-conten1 .notice-des
	{
		width: 565px;
		margin-left: 40px;
		/* display: flex;
		flex-flow: column;
		justify-content: center; */
	}
	.notice-con
	{
		margin-left: 28px;
		margin-top: 40px;
		text-indent: 30px;
	}
	.notice-conten1 .notice-des .notice-con p
	{
		text-indent: 30px;
		margin: 0;
	}
	.notice-head
	{
		height: 45px;
		line-height: 45px;
		border-left: 7px solid #bf0606;
		padding-left: 24px;
		font-size: 35px;
		/* border-bottom: 1px solid #cccccc; */
	}
	.line1
	{
		width: 312px;
		height: 1px;
		margin-top: 10px;
		background: #ccc;
	}
	.line2
	{
		width: 448px;
		height: 1px;
		margin-top: 10px;
		background: #ccc;
	}
	.notice-con
	{
		font-size: 24px;
		line-height: 45px;
	}
	.server
	{
		/* display: flex; */
		padding: 30px 0;
		overflow: hidden;
	}
	.server-top
	{
		overflow: hidden;
	}
	.server-top img
	{
		float: left;
	}
	.server .server-con
	{
		padding-left: 90px;
		box-sizing: border-box;
	}
	.server-head
	{
		margin-left: 20px;
		padding-top: 56px;
		float: left;
		font-size: 38px;
		color: #bf0606;
		border-bottom: 1px solid #ccc;
		padding-bottom: 5px;
	}
	.server .server-con .server-list .server-item
	{
		height: 45px;
		float: left;
		width: 48%;
		border-left: 7px solid #bf0606;
		padding-left: 20px;
		padding-right: 20px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;
	}
	.server .server-con .server-list .server-item a
	{
		color: #000;
	}
	.server .server-con .server-list .server-item:nth-of-type(2n)
	{
		float: right;
	}
	.server .server-con .server-list .server-item .server-title
	{
		font-size: 28px;
		max-width: 500px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.bannerB img
	{
		width: 100%;
	}
	@media screen and (max-width: 1680px) and (min-width:640px) {
		.content-view
		{
			width: 1200px !important;
		}
		.notice-conten1 img
		{
			height: 350px;
		}
		.notice-conten2 img
		{
			height: 310px;
		}
		.notice-head
		{
			height: 45px;
			font-size: 30px;
		}
		.notice-con
		{
			font-size: 24px;
			line-height: 36px;
		}
		.notice-title
		{
			font-size: 32px;
		}
		.notice-conten2 .notice-des
		{
			margin-left: 40px;
			width: 450px;
		}
		.line1
		{
			width: 280px;
		}
		.line2
		{
			width: 400px;
		}
		.notice-conten3>div .title
		{
			width: 160px;
			height: 60px;
			line-height: 60px;
			font-size: 24px;
		}
		.notice-conten3>div .cont
		{
			height: 400px;
			font-size: 16px;
			line-height: 30px;
		}
		.server-head
		{
			font-size: 32px;
		}
		.server .server-con .server-list .server-item .server-title
		{
			font-size: 24px;
			max-width: 400px;
		}
	}
	@media screen and (max-width: 640px){
		.content-view
		{
			width: 100%;
			margin: auto;
		}
		.logo
		{
			padding: 0 2vw;
			box-sizing: border-box;
			margin-top: 10px;
			display:block;
			justify-content:space-between;
			align-items:center;
		}
		.logo a
		{
			color: #000;
			font-size: 16px;
			display: none;
		}
		.logo img
		{
			/* height:60px; */
			width: 96vw;
			height: auto;
		}
		.banner
		{
			margin-top: 13px;
		}
		.banner img
		{
			width: 100%;
		}
		.notice
		{
			margin-top: 5vw;
		}
		.notice-title
		{
			padding: 0 2vw;
			font-size: 24px;
			font-weight: bold;
			color: #444444;
			text-align: center;
		}
		.notice-conten1 img
		{
			width: 96vw;
			height: auto;
		}
		.notice-conten2 img
		{
			width: 96vw;
			height: auto;
		}
		.notice-conten1
		{
			background: #f5f5f5;
			padding: 2vw;
			box-sizing: border-box;
			margin-top: 2vw;
			display: block;
		}
		.notice-conten2
		{
			background: #f5f5f5;
			padding: 2vw;
			box-sizing: border-box;
			margin-top: 2vw;
			display: block;
			justify-content: space-between;
		}
		.notice-conten3
		{
			background: #f5f5f5;
			padding-top: 3vw;
			box-sizing: border-box;
			margin-top: 2vw;
			display: block;
		}
		.notice-conten3>div
		{
			width: 100%;
			flex: 1;
			/* padding: 0 10px; */
		}
		.notice-conten3>div .title
		{
			width: 180px;
			height: 60px;
			line-height: 60px;
			background: #ffffff;
			
			margin: auto;
			margin-bottom: 12px;
			margin-top: 5vw;
			font-size: 24px;
			text-align: center;
		}
		.notice-conten3>div .cont
		{
			background: #ffffff;
			font-size: 18px;
			height: auto;
			line-height: 32px;
			padding: 5px 15px;
			padding-bottom: 20px;
		}
		.notice-conten2 .notice-des
		{
			width: 100%;
			margin-left: 0;
			margin-bottom: 2vw;
		}
		.notice-conten1 .notice-des
		{
			width: 100%;
			margin-left: 0;
			/* display: flex;
			flex-flow: column;
			justify-content: center; */
		}
		.notice-con
		{
			margin-left: 0;
			margin-top: 2vw;
			text-indent: 0;
			text-align: center;
		}
		.notice-conten1 .notice-des .notice-con p
		{
			text-indent: 0;
			margin: 0;
		}
		.notice-head
		{
			height: 36px;
			line-height: 36px;
			border-left: 7px solid #bf0606;
			padding-left: 0;
			font-size: 24px;
			margin-top: 3vw;
			text-align: center;
			font-weight: bold;
			/* border-bottom: 1px solid #cccccc; */
		}
		.line1
		{
			display: none;
			width: 312px;
			height: 1px;
			margin-top: 10px;
			background: #ccc;
		}
		.line2
		{
			display: none;
			width: 448px;
			height: 1px;
			margin-top: 10px;
			background: #ccc;
		}
		.notice-con
		{
			font-size: 18px;
			line-height: 28px;
		}
		.server
		{
			/* display: flex; */
			padding: 5vw 2vw;
			width: 100%;
			overflow: hidden;
			margin-top: 3vw;
		}
		.server-top
		{
			overflow: hidden;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.server-top img
		{
			height: 20vw;
			float: none;
		}
		.server .server-con
		{
			padding-left: 0;
			box-sizing: border-box;
		}
		.server-head
		{
			margin-left: 3vw;
			padding-top: 0;
			float: none;
			font-size: 24px;
			color: #bf0606;
			border: none;
			/* border-bottom: 1px solid #ccc; */
			padding-bottom: 0;
		}
		.server .server-con .server-list .server-item
		{
			height: 36px;
			float: none;
			width: 100%;
			border-left: 7px solid #bf0606;
			padding-left: 2vw;
			padding-right: 0;
			margin-top: 3vw;
			box-sizing: border-box;
			display: flex;
			justify-content: space-between;
			align-items: center;
			cursor: pointer;
		}
		.server .server-con .server-list .server-item a
		{
			color: #000;
		}
		.server .server-con .server-list .server-item:nth-of-type(2n)
		{
			float: none;
		}
		.server .server-con .server-list .server-item .server-title
		{
			font-size: 20px;
			max-width: 96%;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
		.bannerB img
		{
			width: 100%;
		}
	}
</style>
